import React from 'react';
import divider from '../../assets/divider-img.png';
import image from '../../assets/custom-trading.png';

const CustomisedTrading = () => {
  return (
    <div className="backtest-component">
      <div className="container">
        <div className="backtest-main-wrapper">
          <div className="backtest-heading-description align-c-768">
            <h2>Custom Trading Strategies</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              In the ever-evolving world of finance and trading, a
              one-size-fits-all approach often falls short.We understand that
              every trader has a unique vision and set of goals. Our team
              collaborates closely with clients to design and implement custom
              trading strategies that align with their specific requirements and
              market outlook.
            </p>
            <button>Get Solution Now</button>
          </div>
          <div className="backtest-content">
            <img src={image} alt="backtest-performance" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomisedTrading;
